import { Component } from '@angular/core';

import { pedidoFaturado } from '../../pedido-status';

@Component({
    selector: 'sgt-pedido-status-badge-faturado',
    templateUrl: './pedido-status-badge-faturado.component.html',
    styleUrls: ['./pedido-status-badge-faturado.component.less']
})
export class PedidoStatusBadgeFaturadoComponent {
    status = pedidoFaturado;
}
